import React, { useState, useEffect, useCallback } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import api from "../../../../services/api";
import HeaderLogadoColaborador from "../../../../components/common/Authenticated/Colaborador/Header/HeaderLogadoColaborador";
import ItemAgendaCard from "../../../../components/Authenticated/Colaborador/Agenda/ItemAgendaCard";
import BottomMenuColaborador from "../../../../components/common/Authenticated/Colaborador/Menu/Menu";

function Agenda() {
  const usuarioStorage = JSON.parse(localStorage.getItem("usuario")) || {};
  const [agenda, setAgenda] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const carregarAgenda = useCallback(async () => {
    if (!usuarioStorage?._id) return;

    try {
      setLoading(true);
      const { data } = await api.post(`/agendamento/filter/${usuarioStorage._id}`);
      if (!data.error && data.agendamentosPorDia) {
        setAgenda(data.agendamentosPorDia);
      } else {
        setAgenda({});
      }
    } catch (err) {
      console.error("Erro ao carregar agenda:", err);
      setAgenda({});
    } finally {
      setLoading(false);
    }
  }, [usuarioStorage?._id]);

  useEffect(() => {
    carregarAgenda();
  }, [carregarAgenda]);

  const handleDateChange = (date) => setSelectedDate(date);
  const selectedKey = moment(selectedDate).format("YYYY-MM-DD");
  const agendamentosDoDia = agenda[selectedKey] || [];

  const getStatus = (item) => {
    if (item.status === "C") return "Cancelada";
    const dataItem = moment(item.data);
    if (dataItem.isSameOrAfter(moment()) && item.status === "A") return "Agendada";
    return "Realizada";
  };

  return (
    <>
      <HeaderLogadoColaborador />

      <div className="p-5 space-y-1 bg-white min-h-svh">
        <h1 className="text-3xl font-bold mb-6 text-[#003D42]">Agenda</h1>
        <div className="flex flex-col lg:flex-row gap-6">
          {/* === CALENDÁRIO === */}
          <div className="bg-white rounded-2xl shadow-lg p-4 max-w-sm mx-auto border border-gray-100 h-fit">
            <Calendar
            onChange={handleDateChange}
            value={selectedDate}
            locale="pt-BR"
            className="custom-calendar w-full"
            prev2Label={null}
            next2Label={null}
            tileClassName={({ date, view }) =>
                view === "month"
                ? moment(date).isSame(selectedDate, "day")
                    ? "bg-[#003D42] text-white rounded-lg"
                    : "hover:bg-gray-100 rounded-lg"
                : ""
            }
            tileContent={({ date, view }) => {
                // Só mostrar pontinho na visão de dias (month)
                if (view !== "month") return null;

                const dayKey = moment(date).format("YYYY-MM-DD");
                const hasAgendamento = agenda[dayKey]?.length > 0;

                if (!hasAgendamento) return null;

                const isSelected = moment(date).isSame(selectedDate, "day");
                const dotColor = isSelected ? "bg-white" : "bg-[#003D42]";

                return (
                <div className="flex justify-center mt-1">
                    <span className={`w-1 h-1 rounded-full ${dotColor}`}></span>
                </div>
                );
            }}
            />
          </div>

          {/* === LISTA DE AGENDAMENTOS === */}
          <div className="flex-1 bg-white rounded-2xl shadow-lg p-4 border border-gray-100 flex flex-col mb-24">
            <h2 className="text-xl font-semibold text-[#003D42] mb-2">
                {moment(selectedDate).format("dddd, DD [de] MMMM [de] YYYY")}
            </h2>

            {loading ? (
                <p className="text-gray-500 animate-pulse bg-white">Carregando agendamentos...</p>
            ) : agendamentosDoDia.length === 0 ? (
                <p className="text-gray-500 italic">Não há agendamentos neste dia.</p>
            ) : (
                <div className="">
                {agendamentosDoDia.map((item) => (
                    <ItemAgendaCard
                    key={item.id}
                    intervalo={item.intervaloAtendimento}
                    cliente={item.cliente}
                    status={getStatus(item)}
                    data={item.data}
                    />
                ))}
                </div>
            )}
            </div>

        </div>
      </div>

      <BottomMenuColaborador />

      {/* === ESTILO PERSONALIZADO DO CALENDÁRIO === */}
      <style jsx>{`
        .custom-calendar {
          border: none !important;
          font-family: 'Inter', sans-serif;
          width: 100%;
        }

        .custom-calendar button {
          border-radius: 0.5rem;
          padding: 0.5rem;
          transition: all 0.2s ease;
        }

        .custom-calendar button:hover {
          background-color: #f1f5f9;
        }

        .custom-calendar .react-calendar__navigation button {
          color: #003D42;
          font-weight: 600;
        }

        button.react-calendar__tile {
            color: gray;
        }

        .custom-calendar .react-calendar__tile--now {
          background: #e0f2f1;
          color: #003D42;
          font-weight: 600;
          border-radius: 0.5rem;
        }

        .react-calendar__tile--now:enabled:hover, .react-calendar__tile--now:enabled:focus {
            background: #e0f2f1;
        }

        .custom-calendar .react-calendar__tile--active {
          background: #003D42 !important;
          color: white !important;
        }

        button.react-calendar__navigation__arrow.react-calendar__navigation__prev-button {
            width: 10px;
            font-size: 20px;
        }

        button.react-calendar__navigation__arrow.react-calendar__navigation__next-button {
            width: 10px;
            font-size: 20px;
        }

        span.react-calendar__navigation__label__labelText.react-calendar__navigation__label__labelText--from {
            font-size: 20px;
        }
      `}</style>
    </>
  );
}

export default Agenda;
